export default function cookies() {
  const crumbs = document.cookie.split('; ').map(s => s.split('=')) as [string, string][]
  return new Map<string, string>(crumbs)
}
export enum CookiesMap {
  /**
   * Cookie set when opening WebView in found mobile app
   */
  isFoundMobileUser = 'is_found_mobile_user',

  // Ampush quiz Cookie params to determin if redirect to the ampush results page
  isQcRes = 'is_qc_res',
  isQcAmp = 'is_qc_amp',

  // OneTrust Cookie
  OneTrustConsent = 'OptanonConsent',

  // Cookie Consent
  cookieConsent = 'cookieConsent',
}

export const getDomain = () => {
  const parts = window.location.hostname.split('.')
  const domain =
    parts.slice(-2).join('.') === 'localhost'
      ? parts.slice(-2).join('.')
      : `.${parts.slice(-2).join('.')}`
  return domain
}
